// statusClasses.js (Common Status Styles)
const statusClasses = {
    active: {
      bg: "bg-green-100",
      text: "text-green-700", 
      dot: "bg-green-500",
    },
    hold: {
      bg: "bg-orange-100",
      text: "text-orange-700",
      dot: "bg-orange-500", 
    },
    completed: {
      bg: "bg-blue-100",
      text: "text-blue-700",
      dot: "bg-blue-500",
    },
    approved: {
      bg: "bg-purple-100", 
      text: "text-purple-700",
      dot: "bg-purple-500",
    },
    rejected: {
      bg: "bg-red-100",
      text: "text-red-700",
      dot: "bg-red-500",
    },
    completion_request: {
      bg: "bg-yellow-100",
      text: "text-yellow-700",
      dot: "bg-yellow-500",
    },
  };
  
  export default statusClasses;